module.exports = __webpack_public_path__ + "img/inter-xmas.7f6d6d70.jpg";